var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModels({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "9 9 22 22",
    fill: "#0d85bd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6600_4663",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 19,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1609,
    y: 10.9834,
    width: 18.8235,
    height: 18.8235,
    fill: "#0d85bd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6600_4663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2983 22.7483C13.6447 22.7483 13.0891 22.5196 12.6316 22.062C12.1741 21.6045 11.9453 21.049 11.9453 20.3954C11.9453 19.7418 12.1741 19.1862 12.6316 18.7287C13.0891 18.2712 13.6447 18.0424 14.2983 18.0424V16.4738C14.2983 16.0424 14.4518 15.6732 14.759 15.366C15.0662 15.0588 15.4355 14.9052 15.8669 14.9052H18.2198C18.2198 14.2516 18.4486 13.696 18.9061 13.2385C19.3636 12.781 19.9192 12.5522 20.5728 12.5522C21.2264 12.5522 21.7819 12.781 22.2394 13.2385C22.6969 13.696 22.9257 14.2516 22.9257 14.9052H25.2786C25.71 14.9052 26.0793 15.0588 26.3865 15.366C26.6937 15.6732 26.8473 16.0424 26.8473 16.4738V18.0424C27.5009 18.0424 28.0564 18.2712 28.5139 18.7287C28.9715 19.1862 29.2002 19.7418 29.2002 20.3954C29.2002 21.049 28.9715 21.6045 28.5139 22.062C28.0564 22.5196 27.5009 22.7483 26.8473 22.7483V25.8856C26.8473 26.317 26.6937 26.6862 26.3865 26.9934C26.0793 27.3006 25.71 27.4542 25.2786 27.4542H15.8669C15.4355 27.4542 15.0662 27.3006 14.759 26.9934C14.4518 26.6862 14.2983 26.317 14.2983 25.8856V22.7483ZM18.2198 21.1797C18.5466 21.1797 18.8244 21.0653 19.0532 20.8366C19.2819 20.6078 19.3963 20.33 19.3963 20.0032C19.3963 19.6764 19.2819 19.3987 19.0532 19.1699C18.8244 18.9411 18.5466 18.8268 18.2198 18.8268C17.893 18.8268 17.6152 18.9411 17.3865 19.1699C17.1577 19.3987 17.0434 19.6764 17.0434 20.0032C17.0434 20.33 17.1577 20.6078 17.3865 20.8366C17.6152 21.0653 17.893 21.1797 18.2198 21.1797ZM22.9257 21.1797C23.2525 21.1797 23.5303 21.0653 23.759 20.8366C23.9878 20.6078 24.1022 20.33 24.1022 20.0032C24.1022 19.6764 23.9878 19.3987 23.759 19.1699C23.5303 18.9411 23.2525 18.8268 22.9257 18.8268C22.5989 18.8268 22.3211 18.9411 22.0924 19.1699C21.8636 19.3987 21.7492 19.6764 21.7492 20.0032C21.7492 20.33 21.8636 20.6078 22.0924 20.8366C22.3211 21.0653 22.5989 21.1797 22.9257 21.1797ZM17.4355 24.317H23.71V22.7483H17.4355V24.317ZM15.8669 25.8856H25.2786V16.4738H15.8669V25.8856Z",
    fill: "#0d85bd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModels);
export default __webpack_public_path__ + "static/media/models.328434740896dbed38f8aac6aa86f847.svg";
export { ForwardRef as ReactComponent };